import { render, staticRenderFns } from "./FooterWithBackground.vue?vue&type=template&id=7e035461&scoped=true&"
import script from "./FooterWithBackground.vue?vue&type=script&lang=js&"
export * from "./FooterWithBackground.vue?vue&type=script&lang=js&"
import style0 from "./FooterWithBackground.vue?vue&type=style&index=0&id=7e035461&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e035461",
  null
  
)

export default component.exports